import script from "./CandleClash.vue?vue&type=script&setup=true&lang=ts"
export * from "./CandleClash.vue?vue&type=script&setup=true&lang=ts"

import "./CandleClash.vue?vue&type=style&index=0&id=0b5314b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b5314b1"]])

export default __exports__